require('../../modules/es.reflect.construct');
var path = require('../../internals/path');

module.exports = path.Reflect.construct;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/reflect/construct.js
// module id = 1005
// module chunks = 0